export default __webpack_public_path__ + "assets/WellsFargo-2db04510814aafec73569479645e70bb.svg";